// 是否可以领票
import { jsonp } from '@ifeng-fe/ui_base';
import grounds from '@ifeng-fe/three_terminal/es/base/grounds';
import Toast from '../components/Toast';

// eslint-disable-next-line no-undef
const gysdVoteBase = gysdVoteUrl;
// const gysdVoteBase = 'http://test.activity.ifeng.com';

/**
 * 同时适配端内和端外的请求，端内用原生，端外用 jsonp
 *
 * @param {Object} p
 * @param {String} p.url url 链接
 * @param {Object} p.params get 请求的参数
 * @param {String} p.name 由于 jsonp 要保证 callback 名称不一样，所以这里传一个函数名，用于 callback 的命名
 *
 * @return {Promise} 返回一个 promise
 * */

const request = async ({ url, params, name }) => {
    if (!navigator.onLine) {
        Toast.default({
            content: '网络连接失败，请检查网络设置',
        });

        return;
    }
    if (window.grounds) {
        return grounds
            .nativeRequest({
                url,
                getParams: JSON.stringify(params),
                type: 'get',
            })
            .then(res => {
                return res;
            })
            .catch(() => {
                Toast.default({
                    content: '网络连接失败，请检查网络设置',
                });
            });
    } else {
        return jsonp(url, {
            data: params,
            jsonpCallback: name,
            cache: false,
        })
            .then(res => {
                return res;
            })
            .catch(() => {
                Toast.default({
                    content: '网络连接失败，请检查网络设置',
                });
            });
    }
};

// 投票
export const doGoVote = async ({ token, cateId, questionId, itemId, num }) => {
    const sur = `sur[${questionId}][]`;

    return await request({
        url: `${gysdVoteBase}/ticket/addvote`,
        params: {
            token,
            id: cateId,
            [sur]: itemId,
            num,
        },
        name: 'doGoVote',
    });
};

// 获取邀请码
export const getActiveCode = async token => {
    return await request({
        url: `${gysdVoteBase}/invite/mycode`,
        params: {
            token,
        },
        name: 'getActiveCode',
    });
};
